<div>
  <form class="contact-form" [formGroup]="vermittlungForm" (ngSubmit)="submitForm()">
    <mat-form-field>
      <mat-label> E-Mail </mat-label>
      <input matInput formControlName="email">
    </mat-form-field>
    <mat-form-field>
      <mat-label> Vorname </mat-label>
      <input matInput formControlName="firstName">
    </mat-form-field>
    <mat-form-field>
      <mat-label> Nachname </mat-label>
      <input matInput formControlName="lastName">
    </mat-form-field>
    <mat-form-field>
      <mat-label> Nachricht </mat-label>
      <textarea matInput formControlName="message" rows="5"></textarea>
    </mat-form-field>
    <button mat-raised-button class="btn-contacts" type="submit" [disabled]="vermittlungForm.invalid"> Senden </button>
  </form>
</div>
